import * as React from 'react';
import cx from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function IconButton(_ref) {
  var className = _ref.className,
    children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    className: cx(className, styles['button']),
    onClick: onClick,
    children: children
  });
}